import styled from "@emotion/styled"
import {FormMessageProps} from "@components/shared/FormMessage/types"

export const FormMessageWrapper = styled("div", {
    shouldForwardProp: prop => prop !== "type" && prop !== "dense"
})<Pick<FormMessageProps, "type" | "dense">>(({theme, type, dense}) => ({
    backgroundColor: type === "success" ? theme.colors.G50 : theme.colors.R50,
    color: type === "success" ? theme.colors.G500 : theme.colors.R500,
    padding: "8px 12px",
    lineHeight: dense ? 1.375 : 1.715,
    fontSize: dense ? theme.fontSizes.mobile.body : theme.fontSizes.mobile.h2,
    fontWeight: dense ? theme.fontWeights.body : theme.fontWeights.bold,
    marginTop: 16,
    marginBottom: 16,
    "&:first-child": {
        marginTop: 0,
    },
    "&:last-child": {
        marginBottom: 0,
    },
    [theme.breakpoint.up("md")]: {
        fontSize: dense ? theme.fontSizes.desktop.body : theme.fontSizes.mobile.h2,
        marginTop: 24,
        marginBottom: 24,
        "&:first-child": {
            marginTop: 0,
        },
        "&:last-child": {
            marginBottom: 0,
        }
    }
}))
